import AxiosApi from '../api/axiosApi';
import NavTokenMapService from '../services/navTokenMapService';

class NavigationService {
    static getSiteNavLevel() {
        return AxiosApi.get('Navigation/GetSiteNavLevel', false);
    }

    static checkNavigation(siteNavLevel, navTokenId) {
        return new Promise((resolve, reject) => {
            this.getSiteNavLevel().then(response => {
                if (response !== siteNavLevel) {
                    NavTokenMapService.navigateToToken(navTokenId);
                }
                else {
                    resolve()
                }
            })
        });
    }

    static checkNavigations(siteNavLevels, navTokenId) {
        return new Promise((resolve, reject) => {
            this.getSiteNavLevel().then(response => {
                var siteLevelMatch = false
                var i;
                for (i = 0; i < siteNavLevels.length; i++) {
                    if (siteNavLevels[i] == response) {
                        siteLevelMatch = true;
                    }
                }
                if (!siteLevelMatch) {
                    NavTokenMapService.navigateToToken(navTokenId);
                }
                else {
                    resolve();
                }
            })
        });
    }
}

export default NavigationService;